export const formatTinNumber = (value: string | number | null | undefined) => {
    if (!value) return "";

    const digits = value.toString().replace(/\D/g, "").slice(0, 14);

    const part1 = digits.slice(0, 3);
    const part2 = digits.slice(3, 6);
    const part3 = digits.slice(6, 9);
    const part4 = digits.slice(9);

    let formatted = part1;

    if (part2) formatted += `-${part2}`;
    if (part3) formatted += `-${part3}`;
    if (part4) formatted += `-${part4}`;

    return formatted;
};